@if (day.isValid) {
  <div [class]="dayClass(day)" (click)="clickEvent.emit(day)">
    <div class="number">
      @if (day.times?.length>0) {
        <div [class]="classForStartBracket">[</div>
      }
      <div>{{day.display}}</div>
      @if (day.times != null && day.times[day.times.length-1]?.end != null) {
        <div class="end">]</div>
      }
    </div>
    <div class="info" [innerHTML]="day.info"></div>
  </div>
}
@if (!day.isValid) {
  <div class="empty">
  </div>
}
